import { networkingEvents } from "../data/networkingData";

const NetworkingTimeline = () => {
  return (
    <section
      className="bg-[#DAF4F1] !border-b-0 border-0 border-none xs:border-transparent w-full xs:py-[1rem]  xxs:py-[1rem] pb-20  px-6 font-outfit"
      style={{ outline: "4px solid #daf4f1" }}
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl xs:text-2xl xxs:text-2xl font-bold text-center text-brandBlue mb-4">
          Networking & Side Events
        </h2>
        <p className="text-center text-[#4C7C7D] text-lg xs:text-base xxs:text-base  mb-12">
          Connect, learn, and engage in meaningful side events throughout the
          conference
        </p>

        <div className="relative border-l-4 border-dotted  border-softGreen/60 ml-6 space-y-10">
          {networkingEvents.map((event, i) => (
            <div key={i} className="relative flex items-start pl-10">
              {/* Icon Circle */}
              <div className="absolute -left-7 top-0 bg-white border border-softGreen shadow-md rounded-full w-12 h-12 flex items-center justify-center text-2xl text-purple-700">
                {event.icon}
              </div>

              {/* Content */}
              <div>
                <h3 className="text-xl font-semibold text-brandBlue">
                  {event.title}
                </h3>
                <p className="text-[#4C7C7D] xs:text-sm xxs:text-sm mt-1">
                  {event.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NetworkingTimeline;
